import { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';
import { storeToRefs } from 'pinia';
import { useLoaderAtStartStore } from '@/shared/components/loaders/LoaderAtStartApp/store';

export const homeRoute: RouteRecordRaw = {
  path: `/home`,
  name: AppScreens.Home,
  component: () => import('@/modules/home/views/Home.vue'),
  meta: {
    layout: 'main',
  },
  beforeEnter() {
    const { visible, loaderIsRequired } = storeToRefs(useLoaderAtStartStore());

    visible.value = false;
    loaderIsRequired.value = false;
  },
};
